import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/notes-reconcile.svg'


const _hoisted_1 = { class: "relative w-full flex flex-col" }
const _hoisted_2 = { class: "flex flex-row my-2 items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "notes",
  class: "w-4 h-4 mr-1"
}, null, -1)
const _hoisted_4 = {
  for: "notes",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_5 = { class: "absolute bottom-2 right-2 text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.catatan")), 1)
      ])
    ]),
    _createVNode("textarea", {
      value: _ctx.notes,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNotesChange($event.target.value))),
      disabled: _ctx.isLoading,
      maxlength: 255,
      placeholder: _ctx.$t('codReconcile.dailyDeposit.catatan'),
      class: "w-full min-h-[80px] p-3 border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500"
    }, null, 40, ["value", "disabled", "placeholder"]),
    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.notes.length) + "/255 ", 1)
  ]))
}